import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import { useAuth } from "context";
import { Outlet } from "react-router-dom";
import { setupAxios } from "./core/AuthHelper";
import MDSnackbar from "components/MDSnackbar";

import React, { useEffect } from "react";
import { ErrorBoundary } from "./bugsnagConfig";

const App = () => {
  const { darkMode, logout, snackbarMessage, showSnackbar, saveAuthData } = useAuth();
  useEffect(() => {
    setupAxios(saveAuthData, logout);
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        {!!snackbarMessage.type && (
          <MDSnackbar
            color={snackbarMessage.type === "error" ? "error" : "success"}
            icon={snackbarMessage.type === "error" ? "error" : "checkcircle"}
            title={snackbarMessage.type === "error" ? "Error" : "Success"}
            content={snackbarMessage.message}
            open={showSnackbar}
            bgWhite
          />
        )}
        <CssBaseline />
        <Outlet />
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
